import { call, put } from 'redux-saga/effects';
import UpdateNotificationTokenActions from '../redux/UpdateNotificationTokenRedux';
import { api } from './api';


export function* updatenotificationtokensagas(action: any): Generator<any, void, any> {
  const { notificationToken } = action;
  const response = yield call(api.updateNotificationToken, notificationToken);

  // success?
  if (response.ok) {
    // You might need to change the response here - do this with a 'transform',
    // located in ../Transforms/. Otherwise, just pass the data back from the api.
    yield put(UpdateNotificationTokenActions.updateNotificationTokenSuccess(response.data));
  } else {
    yield put(UpdateNotificationTokenActions.updateNotificationTokenFailure());
  }
}